<template>
  <ion-page>
    <ion-content
      :fullscreen="true"
      :scroll-y="false"
      :style="{ backgroundImage: config.loginscreen && `url(${config.loginscreen}` }"
    />
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue';
import { modalController } from '@ionic/vue';
import Chrome from '@/components/Chrome.vue';
import Install from '@/components/Install.vue';
import Login from '@/components/Login.vue';
import LoginNewLink from '@/components/LoginNewLink.vue';
import OnboardingName from '@/components/OnboardingName.vue';
import store from '@/store';
import AuthService from '@/services/Auth';
import UserService from '@/services/User';

export default defineComponent({
  computed: {
    config: () => store.config,
  },
  async mounted() {
    if (this.$route.query.token) {
      const handleToken = await (async () => {
        let token;
        try {
          token = JSON.parse(atob(this.$route.query.token.split('.')[1]));
        } catch {
          // do nothing
          return true;
        }

        try {
          await UserService.loginWithCode(token.email, token.code);
        } catch {
          const modal = await modalController.create({
            component: LoginNewLink,
            componentProps: {
              email: token.email,
            },
            showBackdrop: false,
            backdropDismiss: false,
          });
          await modal.present();
          return false;
        }

        return true;
      })();

      if (!handleToken) {
        return;
      }
    }

    let boarded = false;
    const token = await AuthService.getToken();

    // If a token is found, start preloading user data
    if (token) {
      const user = await UserService.getProfile();
      boarded = user.onboarding_completed;
    }

    // If logged-in and boarded, go to start
    if (boarded && token) {
      this.$router.push({ name: 'start' });
      return;
    }

    // Or determine whether to login or to board
    const modal = await modalController.create({
      component: token ? OnboardingName : Login,
      showBackdrop: false,
      backdropDismiss: false,
    });
    await modal.present();

    // Finally test if user should see a pwa install banner on ios
    const isiOSChrome = navigator.userAgent.match(/CriOS/i) !== null;
    const isiOSSafari = navigator.userAgent.match(/like Mac OS X/i) !== null;

    if (isiOSChrome) {
      const pwa = await modalController.create({
        component: Chrome,
        showBackdrop: false,
        backdropDismiss: false,
      });
      await pwa.present();
    } else if (isiOSSafari && !navigator.standalone) {
      const pwa = await modalController.create({
        component: Install,
        showBackdrop: false,
        backdropDismiss: false,
      });
      await pwa.present();
    }
  },
});
</script>

<style scoped>
ion-content {
  --background: none;

  background-position: center;
  background-size: cover;
}
</style>

<style>
.modal-wrapper {
  background: none !important;

  @media (min-width: 767px) {
    box-shadow: none !important;
  }
}
</style>
